import React from 'react';
import './assets/css/footer.css'

class Footer extends React.Component{
    render(){
        return(
        <div className="footer" id="footer">
            <footer>
            <h5>© 2020 Jean | Designed by <a href="https://www.twitter/vjeanr">@vjeanr</a></h5>
            </footer>
        </div>
        )
    };
}

export default Footer;